<!-- @format -->

<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      <ion-label *ngIf="equipmentRequest">Édition de la demande d'équipement</ion-label>
      <ion-label *ngIf="!equipmentRequest">Création d'une demande d'équipement</ion-label>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" tabindex="-1">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="equipmentRequest?.status === 'refused'" color="danger">
    <ion-label bold [style.padding-left.px]="8">{{equipmentRequest.statusReason}}</ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="!loading; else loadingTmpl" fxLayout="column" [formGroup]="formGroup">
    <div fxLayout="row wrap">
      <mat-form-field appearance="outline" [style.width.px]="400">
        <mat-label>Type d'équipement</mat-label>
        <mat-select formControlName="kind" [compareWith]="compareWithEntity" required>
          <mat-optgroup *ngFor="let group of kinds | groupBy : 'categoryLabel' | pairs" [label]="group[0]">
            <mat-option *ngFor="let kind of group[1]" [value]="kind">
              <mat-label translate>{{ kind.name }}</mat-label>
            </mat-option>
          </mat-optgroup>
        </mat-select>
        <mat-error *ngIf="formGroup.get('kind').errors?.required">
          <mat-label>Obligatoire</mat-label>
        </mat-error>
      </mat-form-field>

      <app-organizational-unit-select
        class="form-field"
        appearance="outline"
        formControlName="organizationalUnit"
        required
        [style.width.px]="400">
      </app-organizational-unit-select>

      <app-real-estate-structure-select
        class="form-field"
        appearance="outline"
        formControlName="realEstateStructure"
        [organizationalUnit]="formGroup.get('organizationalUnit').value"
        [style.width.px]="400">
      </app-real-estate-structure-select>

      <mat-form-field appearance="outline" [style.width.px]="200">
        <mat-label>Prestataire</mat-label>
        <mat-select formControlName="contractor" [compareWith]="compareWithEntity" required>
          <mat-option *ngFor="let option of contractors | orderBy : 'name'" [value]="option">
            {{ option?.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formGroup.get('contractor').errors?.required">
          <mat-label>Obligatoire</mat-label>
        </mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row wrap">
      <mat-form-field appearance="outline" [style.width.px]="200">
        <mat-label>État</mat-label>
        <mat-select formControlName="state">
          <mat-option [value]="1">Très mauvais état</mat-option>
          <mat-option [value]="2">Mauvais état</mat-option>
          <mat-option [value]="3">Moyen</mat-option>
          <mat-option [value]="4">Bon état</mat-option>
          <mat-option [value]="5">Très bon état</mat-option>
        </mat-select>
        <mat-error *ngIf="formGroup.get('state').errors?.required">
          <mat-label>Obligatoire</mat-label>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [style.width.px]="200">
        <mat-label>Référence prestataire</mat-label>
        <input matInput formControlName="externalReference" />
        <mat-error *ngIf="formGroup.get('externalReference').errors?.required">
          <mat-label>Obligatoire</mat-label>
        </mat-error>
        <mat-error *ngIf="formGroup.get('externalReference').errors?.referenceExists">
          <mat-label>La référence existe déjà</mat-label>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [style.width.px]="200">
        <mat-label>Type de tag d'idenfication</mat-label>
        <mat-select formControlName="tagType">
          <mat-option *ngFor="let type of EquipmentTagType | values" [value]="type">
            <span>{{ EquipmentTagTypeName[type] }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" [style.width.px]="200">
        <mat-label>Code / N° de série du tag</mat-label>
        <input autocomplete="off" matInput formControlName="tagCode" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" [style.width.%]="100">
      <mat-label>Localisation précise de l'équipement</mat-label>
      <input autocomplete="off" matInput formControlName="location" />
    </mat-form-field>

    <mat-form-field appearance="outline" [style.width.%]="100">
      <mat-label>Commentaire</mat-label>
      <textarea matInput formControlName="comment"></textarea>
    </mat-form-field>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons *ngIf="equipmentRequest?.status === 'requested' && isAdministrator" slot="start">
      <ion-button
        color="warn"
        fill="clear"
        (confirm)="reject($event)"
        confirmMessage="Êtes-vous sûr de vouloir rejeter la demande ?"
        [askForReason]="true"
        [reasonMandatory]="true">
        Rejeter la demande
      </ion-button>
      <ion-button
        color="ok"
        fill="clear"
        (confirm)="validate()"
        confirmMessage="Êtes-vous sûr de vouloir valider la demande ? La validation entraine la création de l'équipement et la suppression de la demande">
        Valider la demande
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="!equipmentRequest"
        color="primary"
        fill="clear"
        [disabled]="loading || updating || !formGroup?.valid"
        (click)="addNew()">
        Enregistrer la demande
      </ion-button>
      <ion-button
        *ngIf="equipmentRequest"
        color="primary"
        fill="solid"
        [disabled]="loading || updating || !formGroup?.valid || !formGroup?.dirty"
        (click)="edit()">
        <span>Enregistrer les modifications</span>
      </ion-button>
      <ion-button
        *ngIf="equipmentRequest"
        color="danger"
        [disabled]="loading || updating"
        (confirm)="remove()"
        confirmMessage="Êtes-vous sûr de vouloir supprimer la demande ?">
        <span>Supprimer la demande</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<sesio-loader *ngIf="updating" @fadeOut [backdrop]="true"></sesio-loader>

<ng-template #loadingTmpl>
  <sesio-loader @fadeOut></sesio-loader>
</ng-template>
